import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from 'react-bootstrap';
import logo from '../logo.png';
import AuthContext from '../store/auth-context';
import UserAccountIcon from './UserAccountIcon';
import '../styles/components/header.scss';

const Header = () => {
  const auth = useContext(AuthContext);
  const { isLoggedIn } = auth;

  return (
    <>
      {isLoggedIn && (
        <Navbar className="px-2 px-md-4">
          <Link to={'/'} className="text-decoration-none">
            <Navbar.Brand className="me-0 me-md-3">
              <img alt="" src={logo} />
            </Navbar.Brand>
          </Link>
          <UserAccountIcon isLoggedIn={isLoggedIn} logout={auth.logout} />
        </Navbar>
      )}
    </>
  );
};

export default Header;
